<template>
  <hm-content title="">
    <div>
      <div class="g-card">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="170px"
        >
          <div id="base" class="baseTitle mb20">1.基本信息</div>
          <el-form-item label="静态人群名称" prop="tagName">
            <el-input
              maxlength="120"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.tagName"
              placeholder="请输入静态人群名称"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="静态人群分类" prop="sysCategoryFrontendDisplayId">
            <el-select
              v-model="ruleForm.sysCategoryFrontendDisplayId"
              placeholder="请选择静态人群分类"
            >
              <el-option
                v-for="item in tagGroupList"
                :key="item.id"
                :label="item.categoryName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="importDataList">
            <div class="flex item-center">
              <el-button
                type="primary"
                @click="output('模板')"
                :loading="isOutputing"
                size="small"
                style="height: 32px"
                >下载模板</el-button
              >
              <div class="mr20"></div>
              <span class="open-file pointer" v-if="!id">
                <input
                  class="pointer"
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
                <el-button class="pointer" type="primary" size="small"
                  >导入数据</el-button
                >
              </span>
            </div>

            <div class="table mt20">
              <el-table
                stripe
                border
                ref="table"
                :data="memberTemplateList"
                style="width: 100%"
                size="small"
                max-height="400"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="member_name"
                  label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="member_mobile"
                  label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="source"
                  label="名单来源"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>
        <div class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            v-if="!id"
            >发布</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </div>
    </div>
  </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
import { getLoginUser } from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {},
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (!this.memberTemplateList.length) {
        return callback(new Error("请导入数据"));
      }
      callback();
    };
    return {
      storeCode: "",
      id: "",
      ruleForm: {
        tagName: "",
        sysCategoryFrontendDisplayId: "",
        customType: "people",
        importDataList: [],
      },
      rules: {
        tagName: {
          required: true,
          message: "请输入静态人群名称",
          trigger: "blur"
        },
        sysCategoryFrontendDisplayId: {
          required: true,
          message: "请选择静态人群分类",
          trigger: "change"
        },
        importDataList: {
          required: true,
          validator: validatorFunc,
          trigger: "blur"
        },  
      },
      tagGroupList: [],
      isOutputing: false,
      memberTemplateList: [],
      parentId2: "",
    };
  },
  created() {
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.init();
    if(this.$route.query.sysCategoryFrontendDisplayId){
      this.ruleForm.sysCategoryFrontendDisplayId = this.$route.query.sysCategoryFrontendDisplayId
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.queryById();
    }
  },
  methods: {
    async init(){
      await this.queryParentId2();
      await this.queryTypeTag();
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        this.ruleForm.importDataList = this.memberTemplateList;
        this.$store.dispatch("redirectMp",
          {
            importDataList: this.ruleForm.importDataList,    
            mpUrl: "/mp_member/storeMemberCenterInfo/batchCheckAndAddCenterInfo",
            storeCode: this.storeCode,     
          }
        ).then(res2=>{
          this.ruleForm.importDataList = res2.result;
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          console.log("params:",params);
          let url = "importCustomTagData";
          if(this.taskType === 'edit'){
            url = "guiderTaskUpdate"
            params.taskId = this.taskId;
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.back(-1);
            }
          });
        });
      } else {
        return false;
      }
    },
    async queryParentId2(){
      const { result } = await this.$store.dispatch(
        "sysCategoryFrontendDisplayInfoQueryByName",
        {
          categoryName: "人群包根节点",          
        }
      );
      if(result){
        this.parentId2 = result.id;
      }
    },
    async queryTypeTag() {
      const { storeCode } = getLoginUser();
      const { result } = await this.$store.dispatch("querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId", {
        parentId: this.parentId2,
        pageNo: 1,
        pageSize: 9999,        
      });
      this.tagGroupList = result.records;
    },
    async queryById() {
      const { result } = await this.$store.dispatch(
        "tagCustomSourceInfoQueryById",
        {
          id: this.id,
        }
      );
      if (result) {
        this.ruleForm = result.model;
        this.ruleForm.importDataList = result.datas;
        this.memberTemplateList = result.datas;
      }
    },
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      this.fileName = f.name;
      let reader = new FileReader();
      reader.onload = (e) => {
        let data = e.target.result;

        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          if (roa.length) {
            result = roa;
          }
        });
        let arr = [];
        console.log("上传:", result);

        result.map((v) => {
          let obj = {};
          obj.source = v.名单来源;
          obj.member_mobile = v.会员手机号;
          obj.member_name = v.会员姓名;
          arr.push(obj);
        });
        this.memberTemplateList = [...arr];
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导出excel
    output(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        let list = [];
        console.log("this.$refs.table:", this.$refs.table);
        const tHeader = this.$refs.table.columns
          .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
          .filter((o) => o);
        let filterVal = [];
        if (list.length > 0) {
          filterVal = this.$refs.table.$children
            .map((o) => o._props.prop)
            .filter((o) => o);
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>
<style lang="scss" scoped>
.baseTitle {
  font-size: 18px;
  border-bottom: solid 1px #e9eef7;
  padding-bottom: 10px;
}
</style>
